export default __webpack_public_path__ + "static/promo-modal-soc-d25f6ce3cf7637d00129c0e16339a902.png";